// Dashboard Events map & categories page translations (pt-BR), loaded into dashboard.events.categories by ../pt-BR.events.js
module.exports = {
  menu: "Mapa & Categorias",
  title: "Mapa & Categorias",
  description: "Eventos ativos a {end} — {selection}.",
  all: "Todas",
  allCategories: "todas as categorias",
  activeSub: "ativos",
  kpis: {
    active: "Eventos ativos",
    topContinent: "Continente líder",
    topCity: "Cidade líder",
    cities: "Cidades com eventos",
  },
  info: {
    active: "Eventos ativos a decorrer no último dia do período, na categoria escolhida.\nFonte: Firebase (eventos).",
    topContinent: "Continente com mais eventos ativos no último dia do período, na categoria escolhida.\nFonte: Firebase (eventos).",
    topCity: "Cidade com mais eventos ativos no último dia do período, na categoria escolhida.\nFonte: Firebase (eventos).",
    cities: "Cidades com pelo menos um evento ativo no último dia do período, na categoria escolhida.\nFonte: Firebase (eventos).",
  },
  hints: {
    ofActive: "{pct} do total de eventos ativos",
    ofEvents: "{pct} dos eventos",
    events: "{n} eventos",
  },
  panels: {
    map: "Mapa quente — {selection}",
    mapNote: "Os botões de categoria acima filtram todos os blocos da página. Use o zoom do mapa para ver um país ou cidade em detalhe.",
    continents: "Eventos por continente",
    categories: "Eventos por categoria",
    topCities: "Top cidades — {category}",
    matrix: "Categoria por continente — eventos ativos",
    continentsOf: "Continentes — {category}",
    matrixNote: "Quanto mais verde, mais eventos nessa combinação.",
  },
  table: {
    category: "Categoria",
    total: "Total",
  },
  continentsShort: {
    europe: "Europa",
    southAmerica: "Am. do Sul",
    northAmerica: "Am. do Norte",
    africa: "África",
    asia: "Ásia",
    oceania: "Oceania",
  },
  panelInfo: {
    map: "Eventos ativos no último dia do período por local, na categoria escolhida.\nFonte: Firebase (eventos).",
    continents: "Eventos ativos no último dia do período por continente.\nFonte: Firebase (eventos).",
    topCities: "Cidades com mais eventos ativos da categoria escolhida.\nFonte: Firebase (eventos).",
    categories: "Eventos ativos no último dia do período por categoria.\nFonte: Firebase (eventos).",
    matrix: "Eventos ativos no último dia do período por categoria e continente.\nFonte: Firebase (eventos).",
  },
};
